export default __webpack_public_path__ + "static/media/paypal_btn.093c334d.webp";